import React from 'react';
import { Tooltip } from 'react-tooltip';

import './button.scss';

interface IButtonProps {
  className?: string;
  title?: string;
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  disabled?: boolean;
  pending?: boolean;
  tooltipMessage?: string;
  icon?: React.ReactNode;
}

const Button: React.FC<IButtonProps> = ({
  className,
  title,
  onClick,
  disabled = false,
  pending = false,
  tooltipMessage,
  icon,
}) => {
  const isDisabled = disabled || pending;
  const buttonClass = `button ${className} ${isDisabled ? 'disabled' : ''} ${pending ? 'pending' : ''}`;

  const tooltipId = tooltipMessage ? `button-tooltip-${Math.random().toString(36).substr(2, 9)}` : undefined;

  return (
    <>
      <button
        className={buttonClass}
        onClick={onClick}
        disabled={isDisabled}
        data-tooltip-id={tooltipId}
        data-tooltip-content={tooltipMessage}
      >
        {icon}
        {pending ? 'Loading...' : title}
      </button>

      {tooltipMessage && (
        <Tooltip
          id={tooltipId}
          place="bottom"
        />
      )}
    </>
  );
};

export default Button;
